import { FilteredCreditApplication, UnderReviewTile } from '@applyonline/shared'
import { ECreditApplicationStep } from '@if/core/types'
import UploadFilesTable from '../../../../components/UploadFilesTable'
import { hasMissingDocuments } from '../../../../data/credit-application-selectors'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: FilteredCreditApplication
}
const RequiredDocForDecisionForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const hasMissingDocs = hasMissingDocuments(creditApp, ECreditApplicationStep.Credit)

  return hasMissingDocs ? (
    <main className="general-message">
      {hasMissingDocs && (
        <div>
          <h4 className="subtitle">{t('common.financeApplication')}</h4>
          <h1>{t('decision.creditDocumentRequiredTitle')}</h1>
          <div className="paragraph">
            <p>{t('decision.creditDocumentRequired')}</p>
            <p>{t('identity.notifyEmail')}</p>
          </div>
          <UploadFilesTable creditApp={creditApp} />
        </div>
      )}
    </main>
  ) : (
    <UnderReviewTile />
  )
}

export default RequiredDocForDecisionForm
